import { useLocation } from "react-router-dom"
import AuthHelpers from "./AuthHelpers"

class Helpers {
  getCurrentApp() {
    const loc = useLocation()
    const app = loc.pathname.split("/")[1]
    return app
  }

  collection_to_select_option(data, key = null, key2 = null) {
    const optionObj = []
    Object.entries(data).map((option) => {
      optionObj.push({
        value: option[1].id,
        label: `${option[1][key != null ? key : "label"]}${key2 != null ? " - " + option[1][key2] : ""}`,
        name: option[1].name,
      })
    })
    return optionObj
  }

  value_of_array_to_select_option(data) {
    const optionObj = []
    data.map((obj) => {
      optionObj.push({ value: obj, label: obj })
    })

    return optionObj
  }

  new_form_append(data) {
    Object.keys(data).map((key) => {
      data[key] == null && delete data[key]
    })
    const form = new FormData()
    Object.entries(data).map(([key, value]) => {
      // if object and not file
      if (typeof value === "object" && !(value instanceof File)) {
        value.map((obj) => {
          form.append(key + "[]", typeof obj === "object" ? JSON.stringify(obj) : obj)
        })
      } else {
        form.append(key, value)
      }
    })

    if (localStorage.getItem("user") && AuthHelpers.auth_name()) {
      form.append("updated_by", AuthHelpers.auth_name())
    }

    return form
  }

  unclosed_status(status) {
    if (status != "CMP" && status != "JRR" && status != "CANCELED" && status != "LVE") {
      return true
    }
  }

  isSupportedBrowser() {
    return "Notification" in window && "serviceWorker" in navigator && "PushManager" in window
  }

  open_status(status) {
    if (status == "OPN" || status == "RJO" || status == "RSG" || status == "APN" || status == "DPT" || status == "ARV" || status == "STR") {
      return true
    }
  }

  completed_status(status) {
    if (status == "GUIDE" || status == "CMP" || status == "JRR" || status == "CANCEL") {
      return true
    }
  }
}

export default new Helpers()
